module.exports = __webpack_public_path__ + "img/dongji_ps_13.2528e14a.jpg";